<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'chi-square-table-3';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.chi-square-table-3 {
  $height: 48px;
  $padding: 4px;
  --header-cell-height: #{$height};
  --body-cell-height: #{$height};
  $border: 1pt solid #c0bec7;
  thead {
    tr {
      th {
        background-color: var(--theme-color-1);
        & > div {
          color: #fff;
        }
      }
      &:first-child {
        th {
          background-color: #fff;
          & > div {
            color: #222;
            padding: 0 24px;
          }
        }
      }
      &:nth-child(2) {
        th[rowspan='1'] {
          div {
            border-bottom: 1pt solid #fff;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        & > div {
          font-size: 14px;
          border-left: $border;
          border-bottom: $border;
        }
        &:last-child {
          & > div {
            border-right: $border;
          }
        }
      }
      .empty {
        & > div {
          border-bottom: none;
        }
      }
      &:has(td:nth-child(2).empty) {
        border-bottom: 2pt solid var(--theme-color-1);
        td {
          & > div {
            border-bottom: none;
          }
          &:nth-last-child(1),
          &:nth-last-child(2) {
            border-bottom: none;
          }
          &:not(:first-child) {
            div {
              border-left: none;
            }
          }
        }
      }
      &:last-child {
        td {
          &:first-child,
          &:nth-last-child(1),
          &:nth-last-child(2) {
            &.empty {
              border-bottom: $border;
            }
          }
        }
      }
    }
  }
}
</style>
